<template>
  <div class="home">
    <HeroTemplate>
      <template v-slot:hero-image-mobile>
        <img src="../assets/img/home-hero-mobile-img.svg" alt="">
      </template>
      <template v-slot:hero-image-desktop>
        <img src="../assets/img/home-hero-desktop-img-01.svg" alt="">
      </template>
      <template v-slot:hero-text-subtitle>
        Meet Happy G
      </template>
      <template v-slot:hero-text-title>
        The complete way to <span class="pink-text">own</span> your female health.
      </template>
    </HeroTemplate>
    <TextInCenter>
      <template v-slot:text-center-header>
        For a more informed you
      </template>
      <template v-slot:text-center-body>
        <p>We are reimagining the ob/Gyn experience with a simple, streamlined way to track and treat your vaginal health — which means a healthier you in every way.</p>
        <p>You’ll be able to quickly detect any issues, understand what they mean for you, and easily find the solutions you need.</p>
        <p>The best part? You’ll do it all from the comfort of your home. No waiting rooms, referrals, co-pays, or commutes. Fast, accurate, trustworthy.</p>
        <p>When it comes to your vaginal health, you can have it all.</p>
        <p> <b>Right here, right now.</b> </p>
      </template>
    </TextInCenter>
    <PussyTalk />
    <TextInCenter>
      <template v-slot:text-center-header>
        What the research shows
      </template>
      <template v-slot:text-center-body>
        <p>50% of women incorrectly attempt to self-treat vaginal infections, which makes symptoms worse and increases infection recurrence</p>
        <p>Vaginal Infections and STDs are asymptomatic 50-80% of the time</p>
        <p>Even though young people account for half of the 20 million new STI cases recorded annually, only about 12% were tested for STIs in the last year</p>
      </template>
    </TextInCenter>
    <HereToHelp />
    <div class="personal-app">
      <div class="personal-app-bg">
        <img src="../assets/img/personal-app-bg.svg" alt="">
      </div>
      <div class="personal-app-text">
        <TextInCenter>
          <template v-slot:text-center-header>
            A MORE PERSONAL HEALTH APP
          </template>
          <template v-slot:text-center-body>
            <p>Our solution is pretty simple:</p>
            <p>- At-home screening kits allow you to test for common infections and STDs, at any time, no matter where you are.</p>
            <p>- Your input and results help us constantly learn and improve.</p>
            <p>- Trusted sources and curated medical experts provide all of the information you get from HappyG.</p>
          </template>
        </TextInCenter>
      </div>
    </div>
    <Proactive />
    <VaginalKit />
    <div class="mt-5 mb-5">
      <FooterTop />
    </div>
  </div>
</template>

<script>
import PussyTalk from '../components/homepage/PussyTalk'
import HereToHelp from '../components/homepage/HereToHelp'
import Proactive from '../components/homepage/Proactive'
import VaginalKit from '../components/homepage/VaginalKit'
import FooterTop from '../components/footer/FooterTop'
import TextInCenter from '../components/utils/TextInCenter'
import HeroTemplate from '../components/utils/HeroTemplate'

export default {
  name: 'home',
  components: {
    TextInCenter,
    PussyTalk,
    HereToHelp,
    Proactive,
    VaginalKit,
    FooterTop,
    HeroTemplate
  },
}
</script>

<style lang="scss" scoped>
  .personal-app {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: auto;
  }
  .personal-app-bg {
    grid-column: 1/13;
    grid-row: 1/13;
  }
  .personal-app-text {
    grid-column: 1/13;
    grid-row: 1/13;
  }

  @media (min-width: 768px) {
    .personal-app-bg {
      display: none;
    }
    .personal-app-text {
      margin-top: 3em;
    }
  }
</style>
